import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "m-dropdown-menu__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_popper = _resolveComponent("popper")!

  return (_openBlock(), _createBlock(_component_popper, {
    class: "m-dropdown-menu",
    placement: $props.position,
    hover: $props.hover,
    offsetDistance: $props.offsetDistance.toString(),
    zIndex: $props.zIndex.toString(),
    "onOpen:popper": $options.onOpen,
    "onClose:popper": $options.onClose
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "button-content")
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["placement", "hover", "offsetDistance", "zIndex", "onOpen:popper", "onClose:popper"]))
}